import './SearchComponent.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import PropTypes from 'prop-types';

import { handleTextChange } from 'utils/handle-changes';

import { setOpportunitiesSearchField } from 'containers/Opportunities/store/actions';

import Button from 'components/Button';
import Icon from 'components/Icon';
import Textbox from 'components/Textbox';

class SearchComponent extends React.Component {
    static propTypes = {
        hideSearch: PropTypes.func.isRequired
    };

    constructor() {
        super();

        this.state = {
            searchTerm: ''
        };
    }

    componentWillMount() {
        document.body.classList.add('search-component');
    }

    componentWillUnmount() {
        document.body.classList.remove('search-component');
    }

    handleChange(name, value) {
        this.setState({searchTerm: value});
    }

    handleSearch(event) {
        event.preventDefault();

        if(this.props.auth.user.company != null) {
            this.props.changeLocation(`/freelancers?searchTerm=${this.state.searchTerm}`);
        } else {
            this.props.changeLocation(`/opportunities?searchTerm=${this.state.searchTerm}`);
        }
        this.setState({searchTerm: ''});
    }

    render() {
        return (
            <section className="c-search">
                <form className="c-search__form">
                    <Button className="c-search__button"
                            disabled={this.state.searchTerm === ''}
                            onClick={this.handleSearch.bind(this)}
                            noStyles
                            type="submit">
                        <Icon type="search" />
                    </Button>
                    <Textbox
                        label="Search"
                        name="searchField"
                        onChange={(event) => handleTextChange(this.handleChange.bind(this), event)}
                        placeholder="search"
                        type="text"
                        value={this.state.searchTerm}
                    />
                    <Button className="c-search__close-button"
                            noStyles
                            onClick={this.props.hideSearch.bind(this)}>
                        <Icon type="x" />
                    </Button>
                </form>
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        opportunities: state.opportunities
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        setOpportunitiesSearchField: (searchFieldString) => dispatch(setOpportunitiesSearchField(searchFieldString))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchComponent);



// WEBPACK FOOTER //
// ./src/containers/Search/SearchComponent/index.js